import $ from 'jquery'
import { UpdateItem } from './types'

const debug = require('debug')('pm:apps/latest-updates/api')

export async function fetchLatestPostmarkUpdates(): Promise<UpdateItem[]> {
  debug('fetchFeedItems()')

  const feedUrl = 'https://postmarkapp.com/digest/feed.atom'

  return new Promise((resolve, reject) => {
    $.get({
      url: feedUrl,
      dataType: 'xml',
    })
      .done(response => {
        const entries = $(response).find('entry').toArray()
        const updateItems: UpdateItem[] = []

        entries.forEach(entry => {
          const updateItem = {
            title: $(entry).find('title').text(),
            url: $(entry).find('link').attr('href'),
            date: $(entry).find('published').text(),
          }

          const exists =
            updateItems.find(e => {
              return updateItem.url === e.url
            }) !== undefined

          if (!exists) {
            updateItems.push(updateItem)
          }
        })
        debug('fetched feed items', updateItems)
        resolve(updateItems)
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        debug('fetchFeedItems failed', { textStatus, errorThrown })
        reject(new Error(errorThrown || textStatus))
      })
  })
}
